module.exports = __webpack_public_path__ + "img/search.8f79b228.svg";